module.exports = __webpack_public_path__ + "static/media/pathfinderr51.1e2e9ef0.webp";